<template>
  <div>
    <exposure v-if="clientId > 0" />
    <master-exposure v-else />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Exposure from './Exposure'
import MasterExposure from './MasterExposure'

export default {
  name: 'ExposureReport',
  components: {
    Exposure,
    MasterExposure,
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
}
</script>
